<template>
    <div class="text-input-holder" :data-type="type">
        <label v-if="label" :for="name">{{label}}</label>
        <input :type="input_type" :pattern="input_pattern" v-model="model" :maxlength="max_length" :name="name" :disabled="disabled" :placeholder="placeholder" @keydown="onKeydown" />

        <p class="is-danger" v-if="!hideErrors && name && errors.has(name)">{{errors.first(name)}}</p>
    </div>
</template>

<script>
    export default {

        mixins:[],
        props: ["allowModelSet","value","disabled","name","label","placeholder","type","hideErrors"],
        inject: ['$validator'],
        components: {

        },
        data : function(){       
            return {
                model: this.value,
            };
        },
        computed: {
            input_type(){
                return this.type == 'pin' ? 'text' : this.type;
            },
            input_pattern(){
                return this.type == 'pin' || this.type == 'number' ? '[0-9]*' : false;
            },
            max_length(){
                return this.type == 'pin' ? 1 : false;
            },
        },
        watch :{

            value:function(newVal)
            {
                if(this.allowModelSet) {
                    this.model = this.value;
                }

                if(!newVal)
                    this.model = '';
            },

            model:function(newVal)
            {
                this.$emit('input', newVal);
            }

        },
        created : function(){
            
        },
        mounted : function ()
        {
        },
        methods:{

            onKeydown(e){
                if(e.key === 'Backspace' && !this.model){
                    this.$emit('backspace-empty');
                }
            }

        }
    }
</script>



